// extracted by css-extract-rspack-plugin
export default {"p":"p-X0Rxrl"};